import { AnimatePresence, AnimatePresenceProps, motion, Target } from "framer-motion";
import React, { FC, PropsWithChildren } from "react";

export interface FadeProps {
  visible?: boolean;
  duration?: number;
  additional?: {
    initial?: Target;
    animate?: Target;
    exit?: Target;
  };
  className?: string;
  mode?: AnimatePresenceProps["mode"];
  initial?: boolean;
}

export const Fade: FC<PropsWithChildren<FadeProps>> = ({
  children,
  visible = true,
  duration = 0.2,
  additional = {},
  className,
  mode,
  initial = false,
}) => {
  return (
    <AnimatePresence initial={initial} mode={mode}>
      {visible && (
        <motion.div
          className={className}
          initial={{ opacity: 0, ...additional.initial }}
          animate={{ opacity: 1, ...additional.animate }}
          exit={{ opacity: 0, ...additional.exit }}
          transition={{ ease: "easeOut", duration }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
